module.exports = "<div class=\"bg-light\" ui-view=\"\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/cases/cases.pug
// module id = 295
// module chunks = 0